import React from 'react';
import MissionCard from '../MissionCard/MissionCard';

function Missions() {
  return (
    <div className="">
      <MissionCard />
    </div>
  );
}

export default Missions;
